var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex justify-space-around",attrs:{"fluid":""}},[_c('v-progress-circular',{staticClass:"mt-3",attrs:{"size":200,"width":15,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }